'use es6';

import PropTypes from 'prop-types';
import createChainablePropType from './createChainablePropType';
var logoNames;
var propType;
export function getUniqueLogoNames() {
  if (!logoNames) {
    logoNames = process.env.NODE_ENV === 'production' ? [] : Object.keys(require('ui-images/metadata').logos);
  }

  return logoNames;
}
export function getLogoNamePropType() {
  if (!propType) {
    propType = PropTypes.oneOf(getUniqueLogoNames());
  }

  return createChainablePropType(propType, 'logoName');
}